import React from 'react'
import { NextWrapper } from 'data-fetching-wrapper'
import { initializeApollo } from '@gql/client'
import { ListingNewsDocument, ListingNewsNode, PaginaDocument, PaginaNode } from '@gql/graphql'
import BlogListing from '@components/organisms/BlogListing/BlogListing'

interface Props {
  pagina?: PaginaNode
  listing?: ListingNewsNode
}

const Blog = ({ pagina, listing }: Props) => {
  return <BlogListing {...{ pagina, listing }} />
}

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ preview, previewData, locale }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'blog-home', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { listingNews },
    } = await client.query({
      query: ListingNewsDocument,
      variables: {},
      context: {
        headers,
      },
    })

    if (!listingNews || !listingNews?.news || listingNews?.news?.length == 0) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        pagina,
        listing: listingNews,
      },
      revalidate: 60 * 20,
    }
  },
  '/idee-verdi'
)

export default Blog
